class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

// Opening Quick View shifts browser focus onto a <summary>, and that native
// focus-scroll happens synchronously as part of the click — before
// QuickViewButton's own listener below even runs (it extends MenuDrawer,
// whose inherited constructor/click behavior from global.js runs first via
// super()). So the scroll-lock has to run earlier than that: a document-level
// CAPTURE-phase listener fires before any listener on the button itself,
// guaranteeing we pin the page before anything has a chance to scroll it.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('quick-view-button');
  if (!btn) return;

  // component-quick-view.css already does the actual lock on mobile:
  //   body.quick-view--open, body.quick-view--opening {
  //     position: fixed !important; width: 100% !important; overflow: hidden !important;
  //   }
  // but it never sets `top`, so the fixed body always pins at the very top
  // of the page instead of where the user was scrolled to — that's the jump.
  // MenuDrawer adds that class right after this (synchronous, same click),
  // so setting `top` here — before that paints — fixes it without touching
  // or duplicating the theme's own lock.
  const scrollY = window.scrollY;
  const body = document.body;
  body.style.setProperty('top', `-${scrollY}px`, 'important');

  let unlocked = false;
  const unlockScroll = () => {
    if (unlocked) return;
    unlocked = true;
    clearTimeout(safetyTimer);
    body.style.removeProperty('top');
    window.scrollTo(0, scrollY);
  };
  // Real close (not content-load) — the lock must stay while the modal is
  // actually open, however long that is.
  document.addEventListener('quickview:close', unlockScroll, { once: true });
  // Safety net in case the close event never fires for some reason.
  const safetyTimer = setTimeout(unlockScroll, 60000);
}, true);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    drawerContent.classList.add('quick-view-loading');

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);
        this.setInnerHTML(drawerContent, productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');
          drawerContent.classList.remove('quick-view-loading');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 300);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
